"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var axios_1 = __importDefault(require("axios"));
var Button_1 = __importDefault(require("@mui/material/Button"));
var Link_1 = __importDefault(require("@mui/material/Link"));
var FormControl_1 = __importDefault(require("@mui/material/FormControl"));
var InputLabel_1 = __importDefault(require("@mui/material/InputLabel"));
var Select_1 = __importDefault(require("@mui/material/Select"));
var MenuItem_1 = __importDefault(require("@mui/material/MenuItem"));
var mountIsland_1 = require("../mountIsland");
var Lang_js_1 = require("../Lang.js");
function GetMeetings() {
    var _a = (0, react_1.useState)([]), countries = _a[0], setCountries = _a[1];
    var _b = (0, react_1.useState)([]), cities = _b[0], setCities = _b[1];
    var _c = (0, react_1.useState)('US'), selectedCountry = _c[0], setSelectedCountry = _c[1];
    var _d = (0, react_1.useState)(''), selectedCity = _d[0], setSelectedCity = _d[1];
    var _e = (0, react_1.useState)({
        current_page: 1,
        data: [],
        first_page_url: '',
        last_page: 1,
        next_page_url: null,
        prev_page_url: null,
        total: 0,
    }), meetings = _e[0], setMeetings = _e[1];
    (0, react_1.useEffect)(function () {
        axios_1.default.get("/api/ministry/countries")
            .then(function (response) {
            setCountries(response.data || []);
            setSelectedCountry('US');
        })
            .catch(function (error) { return console.log(error); });
    }, []);
    (0, react_1.useEffect)(function () {
        if (selectedCountry) {
            axios_1.default.get("/api/ministry/cities", { params: { co: selectedCountry } })
                .then(function (response) {
                setCities(response.data || []);
            })
                .catch(function (error) { return console.log(error); });
        }
        else {
            setCities([]);
        }
    }, [selectedCountry]);
    (0, react_1.useEffect)(function () {
        fetchMeetings();
    }, []);
    var fetchMeetings = function () {
        axios_1.default.get("/api/ministry/meetings", { params: { co: selectedCountry, ci: selectedCity } })
            .then(function (response) {
            setMeetings(response.data.data || { data: [] });
        })
            .catch(function (error) {
            console.log(error);
            setMeetings({ data: [] });
        });
    };
    var handleSubmit = function (e) {
        e.preventDefault();
        fetchMeetings();
    };
    if (!meetings)
        return react_1.default.createElement("div", null, "Loading...");
    return (react_1.default.createElement("div", { className: "meetings-container" },
        react_1.default.createElement("form", { onSubmit: handleSubmit },
            react_1.default.createElement("div", null,
                react_1.default.createElement(FormControl_1.default, { size: "small", fullWidth: true },
                    react_1.default.createElement(InputLabel_1.default, null, (0, Lang_js_1.__)('Select Country')),
                    react_1.default.createElement(Select_1.default, { value: selectedCountry, label: (0, Lang_js_1.__)('Select Country'), onChange: function (e) { return setSelectedCountry(e.target.value); } },
                        react_1.default.createElement(MenuItem_1.default, { value: "" }, (0, Lang_js_1.__)('Select one')),
                        countries.map(function (item) { return (react_1.default.createElement(MenuItem_1.default, { key: item.country, value: item.country }, item.country)); })))),
            react_1.default.createElement("div", null,
                react_1.default.createElement(FormControl_1.default, { size: "small", fullWidth: true, disabled: !selectedCountry },
                    react_1.default.createElement(InputLabel_1.default, null, (0, Lang_js_1.__)('Select Nearest City')),
                    react_1.default.createElement(Select_1.default, { value: selectedCity, label: (0, Lang_js_1.__)('Select Nearest City'), onChange: function (e) { return setSelectedCity(e.target.value); } },
                        react_1.default.createElement(MenuItem_1.default, { value: "" }, (0, Lang_js_1.__)('Select one')),
                        cities.map(function (item, index) { return (react_1.default.createElement(MenuItem_1.default, { key: index, value: item.city }, item.city)); })))),
            react_1.default.createElement(Button_1.default, { variant: "contained", type: "submit" },
                (0, Lang_js_1.__)('Click to Show Results'),
                ":")),
        react_1.default.createElement("div", null,
            react_1.default.createElement("div", null, meetings.data.map(function (meeting) { return (react_1.default.createElement("div", { key: meeting.id },
                react_1.default.createElement("div", { className: "meeting-info" },
                    react_1.default.createElement("div", { className: "meeting-location" },
                        react_1.default.createElement("h3", null,
                            (0, Lang_js_1.__)('Location'),
                            ":"),
                        react_1.default.createElement("p", null,
                            meeting.address,
                            react_1.default.createElement("br", null),
                            meeting.city,
                            ", ",
                            meeting.state,
                            react_1.default.createElement("br", null),
                            meeting.country)),
                    react_1.default.createElement("div", { className: "meeting-contact" },
                        react_1.default.createElement("h3", null,
                            (0, Lang_js_1.__)('Contact'),
                            ":"),
                        react_1.default.createElement("p", null,
                            meeting.name,
                            react_1.default.createElement("br", null),
                            react_1.default.createElement(Link_1.default, { href: "mailto:".concat(meeting.email), underline: "hover" }, meeting.email),
                            react_1.default.createElement("br", null),
                            meeting.phone))))); })))));
}
exports.default = GetMeetings;
var meetingsElement = document.getElementById('meetings');
if (meetingsElement) {
    (0, mountIsland_1.mountIsland)(meetingsElement, react_1.default.createElement(GetMeetings, null));
}
